<template>
  <div class='container'
       ref="containerBox"
       @scroll="handleScroll">
    <div ref="stickyBox"
         :class="[{ sticky: isSticky }, { box: !isSticky }]"
         :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky"
                 :scrollToTop="scrollToTop"></titlePage>
    </div>
    <div class='contentBox'>
      <div class="content">
        <div class="list-box flex-column"
             style="margin-top: 30px;">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;">
            <div class="GradientBackground flex-column"
                 style="border-radius:10px 10px 0 0 ;background: #0092FF;color: #fff;">
              <div class=""
                   style="margin-right: 20px;">可提现金额（元）</div>
              <div class="bold"
                   style="font-size: 24px;margin-top:10px;">{{ info.amount || 0 }} </div>
            </div>
            <div class="card"
                 style="border-radius: 0 0 10px 10px;padding: 30px;">
              <el-form :model="ruleForm"
                       :rules="rules"
                       ref="ruleForm"
                       label-width="100px"
                       class="demo-ruleForm">
                <div class="flex-between">
                  <el-form-item label="提现金额"
                                prop="money"
                                style="flex: 0 0 50%;">
                    <el-input v-model="ruleForm.money"></el-input>
                  </el-form-item>
                  <el-form-item label="姓名"
                                prop="name"
                                style="flex: 0 0 50%;">
                    <el-input v-model="ruleForm.name"></el-input>
                  </el-form-item>
                </div>
                <div class="flex-between">
                  <el-form-item label="开户行"
                                prop="bank"
                                style="flex: 0 0 50%;">
                    <el-input v-model="ruleForm.bank"></el-input>
                  </el-form-item>
                  <el-form-item label="银行卡号"
                                prop="card"
                                style="flex: 0 0 50%;">
                    <el-input v-model="ruleForm.card"></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="备注">
                  <el-input v-model="ruleForm.remark"
                            type="textarea"></el-input>
                </el-form-item>

                <el-form-item class="flex-center">
                  <el-button type="primary"
                             :loading="submitting"
                             :disabled="submitting"
                             @click="submitForm('ruleForm')">确认提现</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>

        <div v-if="withdrawTip"
             class="list-box flex-column"
             style="margin-top: 30px;">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;">
            <div class="GradientBackground"
                 style="border-radius:10px 10px 0 0;background: #E0F2FF;font-size: 16px;font-weight: 600;color: #333;">
              提现说明
            </div>
            <div class="card withdraw-tip"
                 style="border-radius: 0 0 10px 10px;padding: 24px 30px;"
                 v-html="withdrawTip"></div>
          </div>
        </div>

        <div class=" "
             style="margin-top: 30px;">
          <div class="GradientBackground flex-between items"
               style="border-radius:10px 10px 0 0 ;background: #E0F2FF;">
            <div style="flex: 0 0 6%; ">姓名</div>
            <div style="flex: 0 0 10%; ">提现金额（元）</div>
            <div style="flex: 0 0 20%; ">开户行</div>
            <div style="flex: 0 0 10%; ">银行卡号</div>
            <div style="flex: 0 0 20%; ">备注</div>
            <div style="flex: 0 0 13%; ">时间</div>
            <div style="flex: 0 0 6%; ">状态</div>
          </div>
          <div style="border-radius: 0 0 10px 10px; background: #fff;">
            <div class="flex-between items"
                 v-for="(item, index) in list"
                 :key="index">
              <div style="flex: 0 0 6%; ">{{ item.name || '' }}</div>
              <div style="flex: 0 0 10%; ">{{ item.amount || '' }}</div>
              <div style="flex: 0 0 20%; ">{{ item.bank || '' }}</div>
              <div style="flex: 0 0 10%; ">{{ item.card || '' }}</div>
              <div style="flex: 0 0 20%;overflow-wrap: break-word;">
                {{ item.remark || '' }}
              </div>
              <div style="flex: 0 0 13%; ">{{ item.create_time || '' }}</div>
              <div style="flex: 0 0 6%; ">{{ item.status == 1 ? '申请中' : item.status == 2 ? '已到账' : '已驳回'
                                }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fotterVue></fotterVue>
  </div>
</template>

<script>
import config from '@/config/config'
import titlePage from '@/components/titlePage.vue'
import fotterVue from '@/components/fotter.vue'
import { debounce } from '@/utils/index'
export default {
  name: '',
  components: {
    titlePage,
    fotterVue,
  },
  data() {
    return {
      info: {},
      isSticky: false,
      stickyBoxTop: 0,
      ruleForm: {
        name: '',
        money: '',
        bank: '',
        card: '',
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        money: [{ required: true, message: '请输入提现金额', trigger: 'blur' }],
        bank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        card: [{ required: true, message: '请输入银行卡号', trigger: 'blur' }],
      },
      searchForm: {
        page: 1,
        size: 10,
      },
      list: [],
      submitting: false,
      withdrawTip: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    this.submitForm = debounce(this.doSubmit, 600, true)
  },
  methods: {
    getInfo() {
      this.$api.index.UserIndex().then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.info = res.data.info
        }
      })
    },
    doSubmit(formName) {
      if (this.submitting) return
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        this.submitting = true
        this.$api.index
          .apply(this.ruleForm)
          .then((res) => {
            if (res.code == 200) {
              this.$message.success('申请成功')
              this.searchForm.page = 1
              this.getInfo()
              this.getList()
              this.$refs[formName].resetFields()
            } else {
              this.$message.error(res.msg || '申请失败')
            }
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop
      const bottomOfWindow =
        this.$refs.containerBox.scrollHeight -
        this.$refs.containerBox.scrollTop -
        this.$refs.containerBox.clientHeight
      if (this.isStatus == true && bottomOfWindow <= 50) {
        this.searchForm.page += 1
        this.isStatus = false
        this.getList()
      }
    },
    scrollToTop() {
      this.$refs.containerBox.scrollTop = 0
    },
    getList() {
      if (this.searchForm.page == 1) {
        this.list = []
      }
      this.$api.index.getList(this.searchForm).then((res) => {
        this.loading = false
        if (res.code == 200) {
          this.list = [...this.list, ...res.data.list]
          this.isStatus = res.data.total > this.list.length ? true : false
        }
      })
    },
    getConfig() {
      this.$api.index.getConfig().then((res) => {
        if (res.code == 200) {
          this.withdrawTip = res.data.withdraw_tip || ''
        }
      })
    },
  },
  mounted() {
    this.scrollToTop()
    this.id = this.$route.query.id
    this.getInfo()
    this.getConfig()
    this.getList()
  },
}
</script>
<style lang='scss' scoped>
.contentBox {
  background: linear-gradient(0deg, #f6f8fe 0%, #f6f8fe 78%, #ceeaff 100%);
  margin-top: 60px;
  min-height: 55vh;
}

.content {
  padding: 30px 0;
}

.tags {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  padding: 0 10px;

  p {
    margin: 0;
    padding: 0;

    &:last-child {
      color: #666;
    }
  }
}

.tagsBorder {
  border-left: 1px solid #d7d7d7;
}

span {
  margin-right: 10px;
}

.interval {
  margin-bottom: 10px !important;
}

.formBox {
  height: 55vh;
  overflow-y: scroll;

  .el-form-item {
    flex: 0 0 40%;
  }
}

.formBox::-webkit-scrollbar {
  display: none;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: #333333;
  background-color: transparent;
}

.list-box {
  font-size: 16px;
}

.items {
  border-bottom: 1px solid #f2f2f2;
  padding: 20px;
}

.withdraw-tip {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  background: #fff;
}

::v-deep .withdraw-tip p {
  margin: 0 0 8px;
}
</style>